/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { donationModelPagedResultSchema } from "../donationModelPagedResultSchema.ts";
import { z } from "zod";

export const getApiDonationsByDateQueryParamsSchema = z.object({
    "StartDate": z.string().datetime({ offset: true }).describe("Фильтр по дате (Начальная дата)").optional(),
"EndDate": z.string().datetime({ offset: true }).describe("Фильтр по дате (Конечная дата)").optional(),
"SortByAmount": z.boolean().describe("Сортировка по сумме платежа").optional(),
"SortByAmountDesc": z.boolean().describe("Сортировка по сумме платежа в обратном порядке").optional(),
"SortByName": z.boolean().describe("Сортировка по никнейму").optional(),
"SortByNameDesc": z.boolean().describe("Сортировка по никнейму в обратном порядке").optional(),
"SortByDate": z.boolean().describe("Сортировка по дате платежа").optional(),
"SortByDateDesc": z.boolean().describe("Сортировка по дате платежа в обратном порядке").optional(),
"SearchQuery": z.string().describe("Строка поиска").optional(),
"Limit": z.coerce.number().int().describe("Пагинация - сколько необходимо получить элементов").optional(),
"Offset": z.coerce.number().int().describe("Пагинация - сколько необходимо пропустить элементов").optional()
    }).optional()

/**
 * @description Успешно
 */
export const getApiDonationsByDate200Schema = z.lazy(() => donationModelPagedResultSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiDonationsByDate400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiDonationsByDate401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiDonationsByDate403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiDonationsByDate500Schema = z.lazy(() => badResponseModelSchema)

export const getApiDonationsByDateQueryResponseSchema = z.lazy(() => getApiDonationsByDate200Schema)